export var isTicketCouponGuard = function (coupon) {
    return 'aviaPriceClass' in coupon;
};
